(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
function enhanceHelpPage(root=document){
  root.querySelectorAll('.rd-help-page--faq .rte:not([data-help-ready])').forEach(content=>{
    content.dataset.helpReady='true';
    const headings=Array.from(content.querySelectorAll(':scope > h1'));
    headings.forEach((heading,index)=>{
      if(index===0){const h2=document.createElement('h2');h2.append(...heading.childNodes);heading.replaceWith(h2);return;}
      const details=document.createElement('details');details.className='rd-help-details';
      const summary=document.createElement('summary');summary.textContent=heading.textContent;
      const body=document.createElement('div');body.className='rd-help-details__body';
      let next=heading.nextSibling;
      while(next && !(next.nodeType===1 && next.tagName==='H1')){const following=next.nextSibling;body.append(next);next=following;}
      details.append(summary,body);heading.replaceWith(details);
    });
  });
}
enhanceHelpPage();
document.addEventListener('shopify:section:load',event=>enhanceHelpPage(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('rd-hero-slideshow')) {
  customElements.define('rd-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-go]'));
      this.pauseButton = this.querySelector('[data-pause]');
      this.current = 0;
      this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.abort = new AbortController();
      const on = (node, event, handler) => node.addEventListener(event, handler, { signal: this.abort.signal });
      this.querySelector('.rd-hero__controls').hidden = false;
      this.show(0);
      on(this.querySelector('[data-next]'), 'click', () => { this.stop(); this.show(this.current + 1); });
      on(this.querySelector('[data-prev]'), 'click', () => { this.stop(); this.show(this.current - 1); });
      this.dots.forEach((dot, index) => on(dot, 'click', () => { this.stop(); this.show(index); }));
      on(this.pauseButton, 'click', () => { this.paused = !this.paused; this.updateRotation(); });
      on(this, 'mouseenter', () => { this.hovered = true; this.updateRotation(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.updateRotation(); });
      on(this, 'focusin', event => { if (!this.contains(event.relatedTarget)) this.stop(); });
      on(document, 'visibilitychange', () => this.updateRotation());
      on(document, 'shopify:block:select', event => { if (this.contains(event.target)) { this.stop(); this.show(1); } });
      this.updateRotation();
    }
    show(index) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.current; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.current)));
    }
    stop() { this.paused = true; this.updateRotation(); }
    updateRotation() {
      clearInterval(this.timer);
      const label = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
      this.pauseButton.setAttribute('aria-label', label);
      this.pauseButton.querySelector('span').dataset.paused = String(this.paused);
      if (!this.paused && !this.hovered && !document.hidden) this.timer = setInterval(() => this.show(this.current + 1), 8000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.ready = false; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-sample-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rd-sample-gallery')) {
  customElements.define('rd-sample-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.rd-samples__track');
      const links = Array.from(this.querySelectorAll('[data-photo]'));
      const dialog = this.querySelector('dialog');
      const full = dialog.querySelector('img');
      let current = 0;
      let trigger;
      let modalCredit;
      const show = index => {
        current = (index + links.length) % links.length;
        full.src = links[current].href;
        full.alt = links[current].querySelector('img').alt;
        modalCredit?.remove();
        modalCredit = undefined;
        const credit = links[current].closest('.rd-samples__card').querySelector('[data-photo-credit]');
        dialog.classList.toggle('rd-samples__dialog--credited', Boolean(credit));
        if (credit) {
          modalCredit = credit.cloneNode(true);
          modalCredit.removeAttribute('data-photo-credit');
          modalCredit.setAttribute('data-modal-credit', '');
          dialog.querySelector('.rd-samples__modal-controls').before(modalCredit);
        }
        dialog.querySelector('[data-count]').textContent = `${current + 1} / ${links.length}`;
      };
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => track.scrollBy({left: Number(button.dataset.step) * (track.clientWidth * .85), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
      links.forEach((link,index) => link.addEventListener('click', event => { event.preventDefault(); trigger=link; show(index); dialog.showModal(); }));
      dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.querySelectorAll('[data-modal-step]').forEach(button => button.addEventListener('click', () => show(current + Number(button.dataset.modalStep))));
      dialog.addEventListener('keydown', event => { if(event.key==='ArrowRight'){event.preventDefault();show(current+1);} if(event.key==='ArrowLeft'){event.preventDefault();show(current-1);} });
      dialog.addEventListener('click', event => { if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();} });
      dialog.addEventListener('close', () => trigger?.focus());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
